/**
 * Writes the room's name for a host ("Teacher", "DJ") as it reads mid-sentence:
 * lowercased, except a term that starts with an acronym.
 */
export function hostTermInSentence(hostTerm: string): string {
  const startsWithAcronym = hostTerm.length > 1 && hostTerm[1] === hostTerm[1].toUpperCase() && hostTerm[1] !== hostTerm[1].toLowerCase()
  return startsWithAcronym ? hostTerm : hostTerm.charAt(0).toLowerCase() + hostTerm.slice(1)
}
